import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import HBox from 'components/common/HBox';

export default function DataRatio(props) {
  const {
    data_reliability,
    data_reliability_yn,
    children,
    ...rest
  } = props;
  if (!children && !data_reliability) return null;
  return (
    <div {...ex('DataRatio', rest)}>
      <HBox>
        <HBox {...ex('Data')}>
          <div {...ex('Value')}>
            {T('데이터비율 : {0}', children || data_reliability)}
          </div>
          {data_reliability != null && (
            <div {...ex('Unit')}>
              {T('%')}
            </div>
          )}
        </HBox>
        {data_reliability_yn === 'N' && (
          <HBox {...ex('Warning')}>
            <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.5 5V7H5.5V5H6.5Z" fill="#FF6060" />
              <path d="M6.5 8V9H5.5V8H6.5Z" fill="#FF6060" />
              <path fillRule="evenodd" clipRule="evenodd" d="M6 1L11.5 10.5H0.5L6 1ZM2.23445 9.5L6 2.99586L9.76555 9.5H2.23445Z" fill="#FF6060" />
            </svg>
            <div>
              {T('데이터 불충분')}
            </div>
          </HBox>
        )}
      </HBox>
    </div>
  );
}
